var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1513_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3091 4.42531C11.2711 3.45339 9.92402 2.92061 8.49495 2.92188C5.92311 2.92413 3.70281 4.68755 3.08978 7.13369C3.04516 7.31176 2.88651 7.4375 2.70293 7.4375H0.800295C0.551338 7.4375 0.362213 7.21149 0.408266 6.96681C1.12668 3.15177 4.47621 0.265625 8.5 0.265625C10.7063 0.265625 12.7099 1.13342 14.1882 2.54618L15.374 1.36033C15.876 0.858334 16.7344 1.21387 16.7344 1.92382V6.375C16.7344 6.81511 16.3776 7.17188 15.9375 7.17188H11.4863C10.7764 7.17188 10.4208 6.31354 10.9228 5.81151L12.3091 4.42531ZM1.0625 9.82812H5.51368C6.22363 9.82812 6.57917 10.6865 6.07717 11.1885L4.69094 12.5747C5.72893 13.5467 7.07608 14.0795 8.50518 14.0782C11.0757 14.0758 13.2969 12.3136 13.9102 9.86637C13.9548 9.68831 14.1135 9.56257 14.2971 9.56257H16.1997C16.4487 9.56257 16.6378 9.78858 16.5918 10.0333C15.8733 13.8482 12.5238 16.7344 8.5 16.7344C6.29372 16.7344 4.29014 15.8666 2.81181 14.4538L1.62596 15.6397C1.12396 16.1417 0.265625 15.7861 0.265625 15.0762V10.625C0.265625 10.1849 0.622393 9.82812 1.0625 9.82812Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1513_811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshV2);
export default __webpack_public_path__ + "static/media/refresh-v2.21ef6d53.svg";
export { ForwardRef as ReactComponent };